import { useCallback } from 'react';

import { roles as ROLES } from 'src/utils/roles';


// ----------------------------------------------------------------------

export function usePermissionChecker({ userRoles = [] }) {

    const hasPermission = useCallback((roles) => {
        if (!roles || roles.length === 0) {
            return false;
        }

        if (userRoles.includes(ROLES.ADMIN)) {
            // Admin has access to everything
            return true;
        }

        return roles.some(role => userRoles.includes(role));
    }, [userRoles]);

    return { hasPermission };
}
